<div class="auth-callback-container" @fadeIn>
  <h1>{{ 'auth.logging-in' | translate }}</h1>

  @if (exchangeState === 'pending') {
    <div>
      <app-spinner [size]="64"></app-spinner>
    </div>
  }

  @if (exchangeState === 'success') {
    <div @fadeIn>
      <span class="state-icon state-icon--success" [appIcon]="'check-circle'"></span>
    </div>
  }

  @if (exchangeState === 'failure') {
    <div @fadeIn>
      <span class="state-icon state-icon--failure" [appIcon]="'error-circle'"></span>
    </div>
  }
</div>
